module.exports = __webpack_public_path__ + "media/images/favicon/apple-icon-57x57-3ce4ecfd99ba040ba65adf7441b5a4fa.png";